import store from '@/store/index'
import { ROLES, USER_INFO } from '@/store/mutation-types'
import Vue from 'vue'

export default function Initializer() {
	store.commit('user/SET_ROLES', Vue.ls.get(ROLES))
	store.commit('user/SET_USER_INFO', Vue.ls.get(USER_INFO))
	store.dispatch('setting/setINITPWD')
	store.dispatch('setting/initAreas')
	store.dispatch('setting/initCompanyTree')
	store.dispatch('setting/initPartnerTree')
	const params: any = [
		{
			list: [
				'TREATMENT',
				'REFERRAL_WAYS',
				'TREAT_WAYS',
				'MENTAL_STATUS',
				'CAREGIVERS_IDENTITY',
				'RELATIONSHIP',
				'WAGE_TYPE',
				'TRAFFIC_SITUATION',
				'IS_PECCANCY',
				'RELATIONSHIP',
				'INJURY_IDENTITY',
				'INJURY_POSITION',
				'SPENT_PREDICT_TYPE',
				'INDEPENDENT',
				'WORK_STATUS',
				'INCOME_PREDICT_TYPE',
				'INJURED_SIGNATURE',
				'CAR_TYPE',
				'CANCEL_TYPE',
				'RELATION_TYPE',
				'HOUSE_TYPE',
				'COMPANY_TYPE',
				'CONTRACT_TYPE',
				'LEAVE_TYPE',
				'LANDLORD_TYPE',
				'COMMITTEE_TYPE',
				'MEDICAL_TYPE',
				'PARTNER_STATUS',
				'DRIVER_FEATURE',
				'ACCIDENT_FEATURE',
				'EXAM_TYPE',
				'EXAM_RESULT',
				'OPERATION_LOG',
				'INJURED_SITE',
				'SURGERY_MATERIAL',
				'EQUIPMENT_FIXATION',
				'JOINT_REPLACEMENT',
				'EXERCISE_TYPE',
				'DISABILITY_LEVEL',
				'OTHER_REQUIRE',
				'AGENT_RELATION',
			],
			type: 'Map',
		},
		{
			list: [
				'TASK_LABEL',
				'MEDIA_TYPE',
				'MANUAL_CONFIG_TYPE',
				'RULE_GEN_TIME',
				'RULE_SYMBOL',
				'ICU_STATUS',
				'RULE_BASE_TYPE',
				'CANCEL_REASON_TYPE',
			],
			type: 'List',
		},
		{
			list: [
				'ID_TYPE',
				'ORDER_STATUS',
				'OPERATION_STATUS',
				'INJURED_TASKTYPE',
				'LOCORDER_STATUS',
				'REVISIT_TASK_STATUS',
				'REVISIT_OPT_STATUS',
				'YES_NO',
				'CHECK_TYPE',
				'CHECK_STATUS',
				'INSURANCE_TYPE',
				'SUBINSURANCE_TYPE',
				'INJURED_LOCATION',
				'ACTIVITY_POSITION',
				'SURVERY_TASKTYPE',
				'INVOICE_TASKTYPE',
				'INVOICE_TASK_STATUS',
				'CONCILIATION_TASKTYPE',
				'CON_ORDER_STATUS',
				'CON_OPERATION_STATUS',
				'DEAL_STATUS',
				'INSURANCE_FORN_TYPE',
				'READ_PAPER',
				'CAR_PROPERTY',
				'INVOLVE_DEATH',
				'AGENT_TYPE',
				'FORN_TYPE',
				'LAWSUI_TTYPE',
				'LAWSUIT_TASKTYPE',
				'LAW_ORDER_STATUS',
				'EXAM_STATUS',
				'EXCEPTION_TYPE',
				'EINVOICE_TASKTYPE',
				'SUB_TASKTYPE',
				'ORDER_TYPE',
				'REVISIT_TYPE',
				'CASE_STATUS',
				'END_TYPE',
				'SELF_DISEASE',
				'HAVE_NONE',
				'SEX',
				'CENSUS_REGISTER_TYPE',
				'EMERGENCY_TYPE',
				'CURETYPE',
				'ACCIDENTAFFECT',
				'INJURY_IDENTITY',
				'TRAFFIC_SITUATION',
				'INJURY_POSITION',
				'IS_PECCANCY',
				'BLAME_TYPE',
				'INJURED_RELATION',
				'BENEFICIARYTYPE',
				'CERTIFiCATETYPE',
				'FRACTURETYPE',
				'DEPENDENT_TYPE',
				'CAREGIVERS_IDENTITY',
				'WAGE_TYPE',
				'HOUSE_NATURE',
				'PRIMARYSITE',
				'PAIC_HOSPITALSUBJECT',
				'EDUCATION',
				'POLITICS',
				'CAREER',
				'EINS_TYPE',
				'SETTLE_STATUS',
			],
			type: ['List', 'Map'],
		},
	]
	return store.dispatch('setting/setSettings', params)
}
